import React from "react";
import { observer } from "mobx-react";

import { DateTime } from "luxon";

import { LiveMatchTimeTooltip } from ".";

import { Event } from "@gp/models";
import TopEventTag from "../../common/TopEventTag";

export const LiveMatchTime = observer(function LiveMatchTime(props: {
	event: Event;
	className: string;
	isSpotlight?: boolean;
	isTopEvent?: boolean;
	isAdditionalOfferVisible?: boolean;
}) {
	const {
		event: { matchTime },
		isSpotlight,
	} = props;

	const tooltipId = `match-time-${props.event.id}`;

	if (props.event.matchTime != undefined) {
		let timeToDisplay = null;

		if (matchTime?.displayTime != null) {
			timeToDisplay = matchTime.displayTime;
		} else if (matchTime != null) {
			timeToDisplay = matchTime.regularTime;
		}

		if (isSpotlight) {
			return <div className={props.className}>{timeToDisplay}</div>;
		}

		return (
			<div className={props.className}>
				<div
					className="offer__time__inner"
					data-tooltip-id={tooltipId}
					data-tooltip-position-strategy="fixed"
				>
					{timeToDisplay}
				</div>

				{!props.isAdditionalOfferVisible && (
					<TopEventTag
						className="offer__time__tag offer__time__tag--top u-icon u-icon--sml u-icon--top--str u-color--rate--low"
						event={props}
					/>
				)}

				<LiveMatchTimeTooltip
					event={props.event}
					tooltipId={tooltipId}
				/>
			</div>
		);
	}

	if (isSpotlight) {
		return (
			<div className={props.className}>
				{DateTime.fromISO(props.event.startTime).toFormat("HH:mm")}
			</div>
		);
	}

	return (
		<div className={props.className}>
			<div
				className="offer__time__inner"
				data-tooltip-id={tooltipId}
				data-tooltip-position-strategy="fixed"
			>
				{DateTime.fromISO(props.event.startTime).toFormat("HH:mm")}
			</div>
			{!props.isAdditionalOfferVisible && (
				<TopEventTag
					className="offer__time__tag offer__time__tag--top u-icon u-icon--sml u-icon--top--str u-color--rate--low"
					event={props}
				/>
			)}
			<LiveMatchTimeTooltip event={props.event} tooltipId={tooltipId} />
		</div>
	);
});
